define('app/views/b2b_contact_form_view',['app/setup'],function(takhfifan) {
  takhfifan.b2bContactFormView = Backbone.View.extend({
    events: {
      "submit":"initiateSubmit"
    },
    initialize: function(options) {
      Backbone.Validation.bind(this);
      this.validForSubmit=false;
    },
    initiateSubmit: function(evt) {
      if(!this.validForSubmit) {
        evt.preventDefault();
        var data = takhfifan.Helper.serializeToObject(this);
        this.model.set(data, { validate: true });
        if(this.model.isValid()) {
          this.validForSubmit=true;
          this.$el.submit();
        }
      }
    }
  });
});

